<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" (click)="onCancel()">
  <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" (click)="$event.stopPropagation()">
    <div class="mb-6 flex items-center justify-between">
      <h2 class="text-lg font-bold text-gray-900">{{ title() }}</h2>
      <button (click)="onCancel()" class="cursor-pointer rounded border p-1 text-gray-500 hover:text-gray-700">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <div class="mb-6" [formGroup]="modificationForm">
      <label class="mb-2 block text-sm text-gray-700">{{ label() }}</label>
      <textarea
        formControlName="comment"
        [placeholder]="placeholder()"
        class="focus-border-black-solid h-32 w-full resize-none rounded-md border border-gray-300 p-3 text-sm focus:outline-none"></textarea>
      @if (modificationForm.get("comment")?.invalid && modificationForm.get("comment")?.touched) {
        @if (modificationForm.get("comment")?.errors?.["required"]) {
          @if (type() === "modify") {
            <p i18n="@@modificationCommentRequired" class="text-sm font-light text-red-600">
              Modification comments are required
            </p>
          }
          @if (type() === "reject") {
            <p i18n="@@rejectCommentRequired" class="text-sm font-light text-red-600">Rejection reason is required</p>
          }
        }

        @if (modificationForm.get("comment")?.errors?.["minlength"]) {
          @if (type() === "modify") {
            <p i18n="@@modificationCommentMinlength" class="text-sm font-light text-red-600">
              Comments must be at least 20 characters
            </p>
          }
          @if (type() === "reject") {
            <p i18n="@@rejectMinlength" class="text-sm font-light text-red-600">
              Rejection reason must be at least 20 characters
            </p>
          }
        }
        @if (modificationForm.get("comment")?.errors?.["maxlength"]) {
          @if (type() === "modify") {
            <p i18n="@@modificationCommentMaxlength" class="text-sm font-light text-red-600">
              Comments cannot exceed 4000 characters
            </p>
          }
          @if (type() === "reject") {
            <p i18n="@@rejectMaxlength" class="text-sm font-light text-red-600">
              Rejection reason cannot exceed 4000 characters
            </p>
          }
        }
        @if (modificationForm.get("comment")?.errors?.["pattern"]) {
          @if (type() === "modify") {
            <p i18n="@@noWhitespace" class="text-sm font-light text-red-600">Admin can not write a comment like that</p>
          }
          @if (type() === "reject") {
            <p i18n="@@rejectMaxlength" class="text-sm font-light text-red-600">
              Rejection reason cannot exceed 4000 characters
            </p>
          }
        }
      }
      @if (subtitle()) {
        <p class="mt-4 text-sm text-gray-500">{{ subtitle() }}</p>
      }
    </div>

    @if (error()) {
      <app-error [apiError]="isArabic() ? 'خطأ داخلي في السيرفر' : isEnglish() ? 'internal server error' : ''" />
    }

    <div class="flex justify-end gap-3">
      <button
        (click)="onOpenModal()"
        class="border-primary text-primary hover-bg-primary-10 rounded-[6px] border px-4 py-2 text-[12px] font-[500] hover:cursor-pointer">
        <span i18n="@@adminCategoryFormButtonCancel">Cancel</span>
      </button>
      <button
        (click)="type() === 'modify' ? onConfirmRequestModification() : onReject()"
        [disabled]="!reason()"
        [class.opacity-50]="!reason()"
        class="bg-primary hover-bg-primary-hover rounded-[6px] px-4 py-2 text-[12px] font-[500] text-white hover:cursor-pointer disabled:cursor-not-allowed">
        @if (loading()) {
          <span i18n="@@loading">loading...</span>
        } @else {
          {{ confirmButtonText() }}
        }
      </button>
    </div>
  </div>
</div>

@if (isModal()) {
  <app-confirmation-close (closeModal)="onCloseModal()" (onCancel)="onCancel()" />
}
